import auth from "./auth";
import api from "./api";

const BASE_SERVICE_URL = "wallet-service";

export default {
    getWallets(param) {
        return new Promise((resolve, reject) => {
            api.get(
                BASE_SERVICE_URL + "/v1/cms/wallet/list/" + param.page,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },
    saveWallet(param) {
        return new Promise((resolve, reject) => {
            api.post(
                BASE_SERVICE_URL + "/v1/cms/wallet/create",
                param,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },
    viewWallet(uuid) {
        return new Promise((resolve, reject) => {
            api.get(
                BASE_SERVICE_URL + "/v1/cms/wallet/view/" + uuid,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },
    updateWallet(uuid, param) {
        return new Promise((resolve, reject) => {
            api.post(
                BASE_SERVICE_URL + "/v1/cms/wallet/update/" + uuid,
                param,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },
    deleteWallet(uuid) {
        return new Promise((resolve, reject) => {
            api.get(
                BASE_SERVICE_URL + "/v1/cms/wallet/archive/" + uuid,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },
    getVoucherOptions() {
        return new Promise((resolve, reject) => {
            api.get(
                "voucher-service/v1/cms/voucher/options/vouchers/not-bundled",
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },
    getRewardOptions() {
        return new Promise((resolve, reject) => {
            api.get(
                "rewards-service/rewards/merchant/options",
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },
    getTransactionHistory(page, filter) {
        return new Promise((resolve, reject) => {
            api.post(
                BASE_SERVICE_URL + "/v1/cms/wallet/transactions/list/" + page,
                filter,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },
    getCustomerWallets(uuid) {
      return new Promise((resolve, reject) => {
        api.get(
          `${BASE_SERVICE_URL}/v1/cms/wallet/customer/wallets/${uuid}`,
          auth.getHeader()
        )
          .then(response => {
            return resolve(response);
          })
          .catch((status, error) => {
            reject(status, error);
          });
      });
    },
    suspendCustomerWallet(payload) {
      return new Promise((resolve, reject) => {
        api.post(
          `${BASE_SERVICE_URL}/v1/cms/wallet/customer/suspend`,
          payload,
          auth.getHeader()
        )
          .then(response => {
            return resolve(response);
          })
          .catch((status, error) => {
            reject(status, error);
          });
      });
    },
    getCappingDetails() {
      return new Promise((resolve, reject) => {
        api.get(
          `${BASE_SERVICE_URL}/v1/cms/wallet/capping/details`,
          auth.getHeader()
        )
          .then(response => {
            return resolve(response);
          })
          .catch((status, error) => {
            reject(status, error);
          });
      });
    },
    saveCappingDetails(payload) {
      return new Promise((resolve, reject) => {
        api.post(
          `${BASE_SERVICE_URL}/v1/cms/wallet/capping/settings/save`,
          payload,
          auth.getHeader()
        )
          .then(response => {
            return resolve(response);
          })
          .catch((status, error) => {
            reject(status, error);
          });
      });
    }
};
